import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { Component } from 'react';
import { Cell, DeprecatedIcon, Spacer, Text } from '@vinted/web-ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

class ProfileInfoBlock extends Component {
  defaultContent() {
    if (!this.props.data) return null;
    const {
      iconName,
      color,
      text,
      enableHtml,
      theme
    } = this.props.data;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(DeprecatedIcon, {
          name: iconName,
          color: color,
          size: DeprecatedIcon.Size.Small
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Spacer, {
          orientation: Spacer.Orientation.Vertical
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Text, {
          text: text,
          html: enableHtml,
          theme: theme
        })
      })]
    });
  }

  renderContent() {
    const {
      children,
      useFlexbox
    } = this.props;
    const content = children || this.defaultContent();
    if (!useFlexbox) return content;
    return /*#__PURE__*/_jsx(Cell, {
      children: /*#__PURE__*/_jsx("div", {
        className: "u-flexbox",
        children: content
      })
    });
  }

  render() {
    return this.renderContent();
  }

}

_defineProperty(ProfileInfoBlock, "defaultProps", {
  useFlexbox: false
});

export default ProfileInfoBlock;